<template>
  <div class="discounts-shadow mb-2">
    <div class="discounts-box p-2" @click.stop.prevent="expanded = !expanded">
      <div class="row w-100 mx-1">
        <div class="discounts-info-wrapper col-3 p-0">
          <router-link :to="{ path: '/jobs/edit/' + discount.job_id }" target="_blank">
            <div class="discount-ref-id pointer">{{ discount.ref_id }}</div>
          </router-link>
          <div class="total-info">
            {{ discount.move_date }}
          </div>
        </div>
        <div class="discounts-info-wrapper col-3 p-0">
          <div class="total-info-numbers text-center">
            {{ discount.name }}
          </div>
        </div>
        <div class="discounts-info-wrapper col-3 p-0">
          <div class="total-info-numbers text-center pl-2">
            <template v-if="discount.discount_unit_type_id === 1">
              ${{ discount.amount }}
            </template>
            <template v-else-if="discount.discount_unit_type_id === 2">
              {{ discount.amount }} ({{ discount.amount_percent }}%)
            </template>
          </div>
        </div>
        <div class="discounts-info-wrapper col-3 p-0">
          <div class="total-info-numbers pr-2 text-right">
            {{ discount.type }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="expanded" class="discounts-box p-2">
      <div class="border-top-expanded row mx-1 w-100">
        <div class="col-12 row mt-2 pr-0">
          <div class="col-4">
            <label class="expanded-label">Booked company</label>
            <div class="expanded-col-data">
              {{ discount.company }}
            </div>
          </div>
          <div class="col-4">
            <label class="expanded-label">Carrier</label>
            <div class="expanded-col-data">
              {{ discount.carrier }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiscountsBlockMobile',
  props: {
    discount: {
      type: Object,
      default: () => ({}),
    },
    expandedAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  watch: {
    expandedAll() {
      this.expanded = this.expandedAll;
    },
  },
};
</script>

<style scoped>
.discounts-box {
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  border-radius: 2px;
  min-height: 70px;
}

.discount-ref-id {
  font-weight: bold;
  font-size: 12px;
  color: #4c5669;
}

.discounts-shadow {
  box-shadow: 0 2px 9px -4px rgba(15, 20, 54, 0.17), 0 7px 25px -3px rgba(50, 50, 93, 0.03);
}

.discounts-box > div:first-child > div:first-child {
  padding: 12px 0 0 12px !important;
}
.discounts-info-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.total-ref-id {
  font-weight: bold;
  font-size: 12px;
  color: #4c5669;
}
.total-ref-id:hover {
  color: #2962ff;
}
.total-info {
  font-size: 10px;
  color: #4c5669;
}
.total-info-numbers {
  font-size: 12px;
  color: #4c5669;
}
.discounts-icon {
  color: #c0c6cc;
}

.expanded-label {
  font-weight: bold;
  font-size: 12px;
  color: #4c5669;
  white-space: nowrap;
}

.expanded-col-data {
  font-size: 12px;
  color: #4c5669;
}

.border-top-expanded {
  border-top: 1px solid #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/DiscountsBlockMobile.vue